import React from 'react';
import { List, Datagrid, TextField, DateField, ShowButton } from 'react-admin';
import BooleanIntegerField from '../../fields/BooleanIntegerField';
import ToggleApproveButton from './ToggleApproveButton';
import ToggleEnableGlobalwiseButton from './ToggleEnableGlobalwiseButton';
import ExerciseFilters from './ExerciseFilters';

const ExerciseList = props => (
  <List {...props} filters={<ExerciseFilters />} bulkActionButtons={false}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="coach.full_name" label="Coach" />
      <DateField source="created_at" showTime />
      <BooleanIntegerField source="public" />
      <BooleanIntegerField source="enabled" />
      <BooleanIntegerField source="approved" />
      <ToggleApproveButton />
      <ToggleEnableGlobalwiseButton />
      <ShowButton />
    </Datagrid>
  </List>
);

export default ExerciseList;



// WEBPACK FOOTER //
// ./src/resources/exercises/ExerciseList.jsx